import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

/**
 * Route gate. Unauthenticated users are sent to /login (with a return path).
 * `accreditedOnly` additionally requires the server-assigned
 * accredited-investor role; `reviewerOnly` requires admin/employee;
 * `adminOnly` (FEA-30) requires `role === 'admin'` - matching the backend's
 * `requireAdmin` short-circuit on the `/admin/*` routes it guards. All three
 * are UX gates only - the backend enforces the real authorization on every
 * API call.
 */
export default function ProtectedRoute({
  children,
  accreditedOnly = false,
  reviewerOnly = false,
  adminOnly = false
}) {
  const { isAuthenticated, isAccredited, isReviewer, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (accreditedOnly && !isAccredited) {
    return <Navigate to="/proof-of-funds" replace />;
  }
  if (reviewerOnly && !isReviewer) {
    return <Navigate to="/" replace />;
  }
  if (adminOnly && user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return children;
}
